import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import SlideBar from '@components/SlideBar';
import Text from '@components/Text';
import colors from '@constants/colors';
import useShop from '@hooks/shop/useShop';
import useAppCustom from '@hooks/useAppCustom';
import useCalculatedRequest from '@store/order/hooks/useCalculatedRequest';
import usePrepareOrder from '@store/order/hooks/usePrepareOrder';
import { Fragment, useState } from 'react';

import styles from './styles.module.scss';

function PurchaseFooter() {
  const [buttonMessage] = useState('밀어서 결제하기');
  const prepareOrder = usePrepareOrder();
  const {
    shopName, totalDiscount, paymentAmount, totalAmount, shopId,
  } = useCalculatedRequest();
  const shop = useShop(shopId);
  const { paymentButtonType } = useAppCustom().payment;

  return (
        <Column as='footer' className={styles.container}
                fullWidth
                spacing={16} >
            <Column spacing={8} fullWidth>
                <Row justify='space-between' fullWidth>
                    <Text color={colors.gray6} fontWeight='bold'
                          size='lg' >
                        상품금액
                    </Text>
                    <Text size='lg' >
                        {totalAmount.toLocaleString()}원
                    </Text>
                </Row>
                <Row justify='space-between' fullWidth>
                    <Text color={colors.gray6} fontWeight='bold'
                          size='lg' >
                        할인금액
                    </Text>
                    <Text size='lg' >
                        -{totalDiscount.toLocaleString()}원
                    </Text>
                </Row>
                <Row justify='space-between' fullWidth>
                    <Text fontWeight='bold'
                          size='xl' >
                        결제금액
                    </Text>
                    <Text size='3xl' fontWeight='bold' color={colors.red} >
                        {paymentAmount.toLocaleString()}원
                    </Text>
                </Row>
            </Column>
            {shop?.orderStatus === 'OPEN' ? (
                <Fragment>
                    {paymentButtonType === 'SLIDE' ? (
                        <SlideBar onConfirm={prepareOrder}>
                            {buttonMessage}
                        </SlideBar>
                    ) : (
                        <Button onClick={prepareOrder}
                                fullWidth >
                            결제하기
                        </Button>
                    )}

                </Fragment>
            ) : (
                <Button disabled fullWidth>
                    준비중
                </Button>
            )}
        </Column>
  );
}

export default PurchaseFooter;
